import React from "react";
import { Outlet } from "@tanstack/react-router";

export const CasesLayout: React.FC = () => {
  return <Outlet />;
};